import {
  Component,
  ElementRef, // DKM-5486 Cedric
  inject, // DKM-5486 Cedric
  EventEmitter,
  Input,
  OnInit,
  Output,
  Pipe,
  PipeTransform,
  SimpleChange,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  DxNumberBoxComponent,
  DxTextBoxComponent,
  DxTextBoxModule,
  DxValidatorComponent,
  DxValidatorModule,
} from 'devextreme-angular';
import { LabelMode } from 'devextreme/common';
import { InputEvent, KeyDownEvent } from 'devextreme/ui/text_box';
import { DxiButtonModule } from 'devextreme-angular/ui/nested';
import { DxButtonModule, DxButtonTypes } from 'devextreme-angular/ui/button';
// DKM-5486 Cedric: ortak yardımcı; eski hâli:
// import { telefonBirlestir, telefonParcala } from '../../masks/telefon.mask'; // DKM-5486 Cedric: ortak yardımcı
import {
  telefonBirlestir,
  telefonGirilenRakam,
  telefonOnekAtilmis,
  telefonParcala,
} from '../../masks/telefon.mask'; // DKM-5486 Cedric (28.10): + baştaki 0'ı atma

@Pipe({
  name: 'alanKodValuePipe',
  standalone: true,
})
export class AlanKodValuePipe implements PipeTransform {
  transform(value: number): string {
    if (value == null) return '';
    else if (typeof value === 'string') return value;
    else return value.toString();
  }
}

@Component({
  selector: 'dk-phone',
  standalone: true,
  imports: [
    CommonModule,
    DxTextBoxModule,
    DxValidatorModule,
    AlanKodValuePipe,
    DxiButtonModule,
    DxButtonModule,
  ],
  templateUrl: './phone.component.html',
  styleUrls: ['./phone.component.scss'],
})
export class PhoneComponent implements OnInit {
  @ViewChild('alanKodBox', { static: false }) alanKodBox: DxTextBoxComponent;
  @ViewChild('telefonBox', { static: false }) telefonBox: DxTextBoxComponent;
  @Input() isReadOnly = false;
  @Input() labelText = '';
  @Input() labelMode: LabelMode = 'outside';
  @Input() alanKodu: any;
  @Input() telefon: any;
  @Input() isTel = true;
  @Input() showGetDataBtn = false;
  @Output() public phoneInputChange: EventEmitter<any> = new EventEmitter();
  @Output() public showGetDataPopup: EventEmitter<any> = new EventEmitter();
  public labelModeNew: LabelMode = null;
  public data = {
    alanKodu: 0,
    telefon: '',
  };
  showGetDataBtnOptions: DxButtonTypes.Properties = {
    stylingMode: 'outlined',
    text: '',
    type: 'default',
    icon: 'eyeopen',
    elementAttr: {
      class: 'ctlBtn',
    },
    width: 32,
    onClick: ($event) => {
      this.showGetDataPopup.emit(true);
    },
    disabled: this.isReadOnly,
  };

  rules: any;

  constructor() {
    this.rules = { X: /[02-9]/ };
  }

  ngOnInit(): void {
    if (this.alanKodu) this.data.alanKodu = this.alanKodu;
    this.data.telefon = this.telefon;
    if (this.labelMode !== 'outside') this.labelModeNew = this.labelMode;
    else this.labelModeNew = null;
  }

  ngOnChanges(simpleChanges: SimpleChanges) {}

  inputChange(e: any, type: string) {
    if (type === 'alan') {
      if (e.value?.length > 0) {
        this.alanKodu = e.value;
        this.data.alanKodu = parseInt(this.alanKodu);
        this.phoneInputChange.emit(this.data);
      } else {
        this.data.alanKodu = null;
        this.phoneInputChange.emit(this.data);
      }
    }
    if (type === 'telefon') {
      this.telefon = e.value;
      this.data.telefon = this.telefon;
      this.phoneInputChange.emit(this.data);
    }
  }

  alanOnInput(e: InputEvent) {
    const inputValue = e.event.target.value || '';

    // Sadece rakamları al
    const digits = inputValue.replace(/\D/g, '');

    // 5 hane dolduysa telefona geç
    if (digits.length === 5) {
      this.focusTelefonKodu();
    }
  }

  alanKeyDown(e: KeyDownEvent) {
    const input = e.event.target as HTMLInputElement;
    const cursorPos = input.selectionStart;
    const value = input.value || '';

    if (e.event.key == 'ArrowRight' && cursorPos == 9) {
      e.event.preventDefault();
      this.focusTelefonKodu();
      return;
    }

    if (e.event.key?.length > 1) {
      return;
    }

    // DKM-5486 Cedric (28.10): alan kodunun ilk hanesine elle yazılan 0 yok sayılır ("0532" yazan kullanıcıda
    // alan kodu "053" olup numara kaymasın). Maskedeki sabit "+90" / "+0" hariç girilen rakama bakılır.
    if (
      e.event.key === '0' && !this.isReadOnly &&
      telefonGirilenRakam(input, this.isTel ? '+\\9\\0 (000)' : '+\\0 (000)') === ''
    ) {
      e.event.preventDefault();
      return;
    }

    // sadece rakamlar
    const digits = value.replace(/\D/g, '');

    // son 
    if ((
      e.event.key == '0' ||
      e.event.key == '1' ||
      e.event.key == '2' ||
      e.event.key == '3' ||
      e.event.key == '4' ||
      e.event.key == '5' ||
      e.event.key == '6' ||
      e.event.key == '7' ||
      e.event.key == '8' ||
      e.event.key == '9') &&
      ((cursorPos == 9 || cursorPos == 8) && digits.length === 5)
    ) {
      e.event.preventDefault();
      this.focusTelefonKodu();
      return;
    }
  }

  telefonKeyDown(e: any) {
    const input = e.event.target as HTMLInputElement;
    const cursorPos = input.selectionStart;
    const value = input.value || '';

    // sadece rakamlar
    const digits = value.replace(/\D/g, '');

    if (e.event.key === 'ArrowLeft' && cursorPos === 0) {
      e.event.preventDefault();
      this.focusAlanKodu();
      return;
    }

    if (e.event.key === 'Backspace' && cursorPos === 0 && digits.length === 0) {
      e.event.preventDefault();
      this.focusAlanKodu();
      return;
    }
  }

  // DKM-5486 Cedric: alan kodu + numara iki ayrı kutuda olduğu için tam numara
  // tek seferde yapıştırılamıyor/kopyalanamıyordu. Yapıştırılan metin tam numaraysa
  // (0532 123 45 67, +90 532 123 4567, 5321234567 ...) iki kutuya bölünür;
  // seçim boşken ya da kutunun tamamı seçiliyken kopyalamada tam numara (05321234567) alınır.
  // Diğer durumlarda tarayıcı/DevExtreme varsayılan davranışı değişmez.
  // Yapıştırma, DevExtreme maskesinden ÖNCE yakalanır (host üzerinde capture dinleyici):
  // maske önce kendi parçasını ("053") yazıp ara değer üretmesin diye.
  private hostEl = inject(ElementRef);
  private yapistirDinleyici = (ev: ClipboardEvent) => this.tamNumaraYapistir(ev);

  ngAfterViewInit(): void {
    this.hostEl.nativeElement?.addEventListener('paste', this.yapistirDinleyici, true);
  }

  ngOnDestroy(): void {
    this.hostEl.nativeElement?.removeEventListener('paste', this.yapistirDinleyici, true);
  }

  tamNumaraYapistir(ne: ClipboardEvent) {
    if (this.isReadOnly) return;
    const metin = ne?.clipboardData?.getData('text') ?? '';
    const parca = this.numaraParcala(metin);
    const telefonKutusu = !!(ne?.target as HTMLElement)?.closest?.('.tel-area');
    let alan: string = null;
    let tel: string = null;
    // DKM-5486 Cedric (28.10, dtokgoz: "başında 0 olursa ihmal et, yapıştırma devam etsin"): eksik numarada da
    // baştaki 0 / ülke kodu atılır, kalan rakamlar alan kodu → numara sırasıyla yerleşir; eski hâli:
    // if (parca) {
    //   alan = parca.alan;
    //   tel = parca.tel;
    // } else if (telefonKutusu) {
    //   // Telefon kutusuna boşluk/tireli 7 haneli numara (123 45 67)
    //   const rakam = metin.replace(/\D/g, '');
    //   if (rakam.length === 7 && rakam !== metin.trim()) tel = rakam;
    // }
    // if (!alan && !tel) return;
    const onekAtilmis = parca ? null : telefonOnekAtilmis(metin);
    if (parca) {
      alan = parca.alan;
      tel = parca.tel;
    } else if (onekAtilmis !== null) {
      // "0532", "0532 123", "+90 532 12": 0 ile başlayan numara alan koduyla başlar (hangi kutuya yapıştırılırsa)
      if (onekAtilmis) {
        alan = onekAtilmis.substring(0, 3);
        tel = onekAtilmis.substring(3) || null;
      }
    } else {
      const rakam = metin.replace(/\D/g, '');
      if (telefonKutusu) {
        // Telefon kutusuna boşluk/tireli 7 haneli numara (123 45 67)
        if (rakam.length === 7 && rakam !== metin.trim()) tel = rakam;
      } else if (rakam.length > 3 && rakam.length < 10) {
        // Alan kodu kutusuna 0'sız eksik numara (532 123 4): fazlası numara kutusuna geçer (maske kesmesin)
        alan = rakam.substring(0, 3);
        tel = rakam.substring(3);
      }
    }
    if (!alan && !tel && onekAtilmis !== '') return;
    ne.preventDefault();
    ne.stopPropagation(); // maske işleyicisine ulaşmasın
    if (!alan && !tel) return; // yalnız "0" yapıştırıldı: yok sayılır
    setTimeout(() => {
      if (alan) this.alanKodBox?.instance?.option('value', alan);
      if (tel) this.telefonBox?.instance?.option('value', tel);
      // DKM-5486 Cedric (28.10): alan kodu tamamlandıysa (yalnız "0532" yapıştırıldı) da numaraya geç; eski hâli:
      // if (alan && tel) this.focusTelefonKodu();
      if (alan && (tel || alan.length === 3)) this.focusTelefonKodu();
    });
  }

  tamNumaraKopyala(e: any) {
    const ne: ClipboardEvent = e?.event?.originalEvent ?? e?.event;
    const input = ne?.target as HTMLInputElement;
    if (!ne?.clipboardData || !input) return;
    const secimVar = input.selectionStart !== input.selectionEnd;
    const tamSecim =
      input.selectionStart === 0 && input.selectionEnd === (input.value || '').length;
    if (secimVar && !tamSecim) return; // kısmi seçim: varsayılan kopyalama
    // DKM-5486 Cedric: birleştirme ortak yardımcıya (masks/telefon.mask) taşındı; eski hâli:
    // const alan = String(this.alanKodBox?.instance?.option('value') ?? '').replace(/\D/g, '');
    // const tel = String(this.telefonBox?.instance?.option('value') ?? '').replace(/\D/g, '');
    // if (!alan || !tel) return;
    // ne.clipboardData.setData('text/plain', '0' + alan + tel);
    const tamNumara = telefonBirlestir(
      this.alanKodBox?.instance?.option('value'),
      this.telefonBox?.instance?.option('value')
    );
    if (!tamNumara) return;
    ne.clipboardData.setData('text/plain', tamNumara);
    e.event?.preventDefault?.();
    if (ne !== e.event) ne.preventDefault?.();
  }

  numaraParcala(metin: string): { alan: string; tel: string } | null {
    // DKM-5486 Cedric: ayrıştırma ortak yardımcıya (masks/telefon.mask → telefonParcala) taşındı; eski hâli:
    // let rakam = (metin || '').replace(/\D/g, '');
    // if (rakam.length === 14 && rakam.startsWith('0090')) rakam = rakam.substring(4);
    // else if (rakam.length === 12 && rakam.startsWith('90')) rakam = rakam.substring(2);
    // else if (rakam.length === 11 && rakam.startsWith('0')) rakam = rakam.substring(1);
    // if (rakam.length !== 10) return null;
    // return { alan: rakam.substring(0, 3), tel: rakam.substring(3) };
    return telefonParcala(metin);
  }

  focusAlanKodu() {
    setTimeout(() => {
      this.alanKodBox.instance.focus();
    });
  }
  focusTelefonKodu() {
    setTimeout(() => {
      this.telefonBox.instance.focus();
    });
  }
}
